// extracted by mini-css-extract-plugin
export default {"actionBox":"ReportsScreen_actionBox__GvSDx"};